<template>
  <section class="review-awards eu" :class="{ desktop: $isDesktop }">
    <div class="hero eu">
      <div>
        <h1>
          <translate>Pitchup.com review awards</translate>
          <br v-if="$isDesktop" /><translate>Spain</translate> 2024
        </h1>
        <review-awards-pages-nav />
      </div>
    </div>

    <review-awards-intro />

    <section id="golds" class="top-5">
      <div class="golds-heading">
        <img
          loading="lazy"
          src="@/assets/images/pitchup-favicon.svg"
          alt=""
          width="36"
          height="32"
        />
        <translate tag="h2" :tt="{ numberOfSites: 20 }">
          Top {numberOfSites} campsites in Spain
        </translate>
      </div>
      <div class="top-5-data">
        <review-awards-top-sites :data="TopSitesESData" />
      </div>
    </section>
    <nuxt-to-meta :nuxt2meta="head" />
  </section>
</template>
<script setup lang="ts">
import SCHEMA_ORGANIZATION from '../../../../json/schemaOrganization.json'
import { computed } from 'vue'

definePageMeta({
  layout: 'default',
})

const TopSitesESData = [
  {
    id: '1',
    name: 'Camping El Sur',
    region: 'Málaga',
    url: '/campsites/spain/andalucia/malaga/ronda/camping-el-sur/',
    rating: 9.8,
    reviewsCount: 23,
    pitchTypes: [
      {
        pitchTypesCount: 15,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 15,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 15,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 10,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '2',
    name: 'FozCamp',
    region: 'Lugo',
    url: '/campsites/spain/galicia/lugo/foz/camping-rapadoira-llas/',
    rating: 9.7,
    reviewsCount: 47,
    pitchTypes: [
      {
        pitchTypesCount: 17,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 5,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 22,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
    ],
  },
  {
    id: '3',
    name: 'Camping Los Escullos',
    region: 'Almeria',
    url: '/campsites/spain/andalucia/almeria/nijar/camping-los-escullos/',
    rating: 9.5,
    reviewsCount: 51,
    pitchTypes: [
      {
        pitchTypesCount: 55,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 8,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 55,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 50,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '4',
    name: 'Camping Enmar',
    region: 'Barcelona',
    url: '/campsites/spain/cataluna/barcelona/pineda-de-mar/camping_enmar/',
    rating: 9.5,
    reviewsCount: 25,
    pitchTypes: [
      {
        pitchTypesCount: 180,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 180,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 180,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 18,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '5',
    name: 'Camping Don Quijote',
    region: 'Salamanca',
    url: '/campsites/spain/castilla-y-leon/salamanca/cabrerizos/camping_don_quijote/',
    rating: 9.4,
    reviewsCount: 106,
    pitchTypes: [
      {
        pitchTypesCount: 40,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 165,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 165,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 8,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '6',
    name: 'Camper Area 7',
    region: 'Alicante',
    url: '/campsites/spain/comunidad-valenciana/alicante/el-campello/camper_area_7/',
    rating: 9.4,
    reviewsCount: 27,
    pitchTypes: [
      {
        pitchTypesCount: 115,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
    ],
  },
  {
    id: '7',
    name: 'Camping y Caravaning Playa De Oyambre',
    region: 'Cantabria',
    url: '/campsites/spain/cantabria/cantabria/san_vicente_de_la_barquera/camping-y-caravaning-playa-de-oyambre/',
    rating: 9.4,
    reviewsCount: 22,
    pitchTypes: [
      {
        pitchTypesCount: 40,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 40,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 40,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 10,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '8',
    name: 'Camping Zumaia',
    region: 'Guipúzcoa',
    url: '/campsites/spain/pais-vasco/guipuzcoa/zumaia/camping_zumaia/',
    rating: 9.3,
    reviewsCount: 39,
    pitchTypes: [
      {
        pitchTypesCount: 35,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 30,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 30,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 14,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '9',
    name: 'Camping Orgiva',
    region: 'Granada',
    url: '/campsites/spain/andalucia/granada/orgiva/camping-orgiva/',
    rating: 9.3,
    reviewsCount: 28,
    pitchTypes: [
      {
        pitchTypesCount: 30,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 30,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 30,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 10,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '10',
    name: 'Camping Regio',
    region: 'Salamanca',
    url: '/campsites/spain/castilla-y-leon/salamanca/santa_marta_de_tormes/camping_regio/',
    rating: 9.1,
    reviewsCount: 75,
    pitchTypes: [
      {
        pitchTypesCount: 126,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 126,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 126,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 24,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '11',
    name: "TAIGA Delta de l'Ebre",
    region: 'Tarragona',
    url: '/campsites/spain/cataluna/tarragona/lampolla/camping-ampolla-playa/',
    rating: 9.1,
    reviewsCount: 39,
    pitchTypes: [
      {
        pitchTypesCount: 88,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 87,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 87,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 90,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
      {
        pitchTypesCount: 26,
        name: 'Rent a tent',
        slug: 'rent-a-tent',
        id: '13',
      },
    ],
  },
  {
    id: '12',
    name: 'Camping Estanyet',
    region: 'Tarragona',
    url: '/campsites/spain/cataluna/tarragona/les-cases-dalcanar/camping_estanyet/',
    rating: 9.1,
    reviewsCount: 35,
    pitchTypes: [
      {
        pitchTypesCount: 59,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 59,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 59,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 32,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '13',
    name: 'Camping La Paz',
    region: 'Asturias',
    url: '/campsites/spain/principado-de-asturias/asturias/llanes/camping_la_paz/',
    rating: 9.0,
    reviewsCount: 41,
    pitchTypes: [
      {
        pitchTypesCount: 30,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 30,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 30,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
    ],
  },
  {
    id: '14',
    name: 'Camping Bell Sol',
    region: 'Barcelona',
    url: '/campsites/spain/cataluna/barcelona/pineda-de-mar/camping-bell-sol/',
    rating: 9.0,
    reviewsCount: 39,
    pitchTypes: [
      {
        pitchTypesCount: 124,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 124,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 40,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 5,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '15',
    name: 'La Pomarada De Somiedo',
    region: 'Asturias',
    url: '/campsites/spain/principado-de-asturias/asturias/pola_de_somiedo/la_pomarada_de_somiedo/',
    rating: 9.0,
    reviewsCount: 29,
    pitchTypes: [
      {
        pitchTypesCount: 25,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 25,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 25,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
    ],
  },
  {
    id: '16',
    name: 'Camperlive Benidorm',
    region: 'Alicante',
    url: '/campsites/spain/comunidad-valenciana/alicante/benidorm/camperlive-benidorm/',
    rating: 9.0,
    reviewsCount: 27,
    pitchTypes: [
      {
        pitchTypesCount: 86,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
    ],
  },
  {
    id: '17',
    name: 'Camping Berceo',
    region: 'La Rioja',
    url: '/campsites/spain/la-rioja/la-rioja/berceo/camping_berceo/',
    rating: 9.0,
    reviewsCount: 21,
    pitchTypes: [
      {
        pitchTypesCount: 40,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 40,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 40,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 14,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '18',
    name: 'Los Olivos Camping Park',
    region: 'Castellón',
    url: '/campsites/spain/comunidad-valenciana/castellon/alcoceber/los_olivos_camping_park/',
    rating: 8.9,
    reviewsCount: 37,
    pitchTypes: [
      {
        pitchTypesCount: 112,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 112,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 112,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 1,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '19',
    name: 'Camping Paloma',
    region: 'Cádiz',
    url: '/campsites/spain/andalucia/cadiz/tarifa/camping_paloma/',
    rating: 8.9,
    reviewsCount: 25,
    pitchTypes: [
      {
        pitchTypesCount: 20,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 20,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 20,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 10,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
  {
    id: '20',
    name: 'Camping Caceres',
    region: 'Cáceres',
    url: '/campsites/spain/extremadura/caceres/caceres/camping_caceres/',
    rating: 8.8,
    reviewsCount: 57,
    pitchTypes: [
      {
        pitchTypesCount: 120,
        name: 'Tent pitches',
        slug: 'tent-pitches',
        id: '4',
      },
      {
        pitchTypesCount: 120,
        name: 'Touring caravan pitches',
        slug: 'touring-pitches',
        id: '3',
      },
      {
        pitchTypesCount: 120,
        name: 'Motorhome pitches',
        slug: 'motorhomes',
        id: '10',
      },
      {
        pitchTypesCount: 8,
        name: 'Lodges, cabins, pods or huts',
        slug: 'lodges-for-hire',
        id: '7',
      },
    ],
  },
]

const { $t, $isDesktop } = useNuxtApp()

const title = computed(() => $t('Pitchup.com review awards') as string)

const description = computed(
  () =>
    $t(
      "Pitchup.com's review awards are based on nearly 200,000 customer reviews from 2024. Here's our shortlist of the top rated campsites.",
    ) as string,
)

const head = computed(() => {
  const images = import.meta.glob<{ default: string }>(
    '@/assets/images/review-awards-og-es.png',
    {
      query: '?url',
      eager: true,
    },
  )
  return {
    title: title.value,
    script: [schemaOrganization.value],
    meta: [
      {
        hid: 'og:title',
        property: 'og:title',
        content: title.value,
      },
      {
        hid: 'og:url',
        property: 'og:url',
        content: 'https://www.pitchup.com/review-awards/2024/spain/',
      },
      {
        hid: 'description',
        name: 'description',
        property: 'og:description',
        content: description.value,
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: images['/assets/images/review-awards-og-es.png'].default,
      },
      {
        hid: 'og:image:width',
        property: 'og:image:width',
        content: '1200',
      },
      {
        hid: 'og:image:height',
        property: 'og:image:height',
        content: '630',
      },
    ],
  }
})

const schemaOrganization = computed(() => ({
  type: 'application/ld+json',
  body: true,
  json: SCHEMA_ORGANIZATION,
  hid: 'schema-organization',
}))
</script>
<style>
@import url('~/assets/css/review-awards.css');
</style>
